module.exports = __webpack_public_path__ + "static/media/promo_2.392a50db.png";